<agr-page-toolbar
  [pageTitle]="'app.cycles' | translate"
  [isEmpty]="(cycles$ | async)?.length === 0"
  [emptyTitle]="'cycle.overview.no-cycles-title' | translate"
  [emptyDescription]="'cycle.overview.no-cycles-description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  data-test="cycle-overview"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'cycle.overview.start-new-cycle' | translate"
  (primaryAction)="addCycle()"
>
  <mat-toolbar>
    <mat-toolbar-row>
      <ng-container class="mat-toolbar__left">
        <div
          class="flex--column spacing--margin-right item-selector"
          *ngIf="(cycles$ | async)?.length > 0"
        >
          <mat-label class="text--small text--gray">
            {{ 'cycle.cycle' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            class="text--small"
            placeholder="{{ 'cycle.overview.placeholder' | translate }}"
            data-test="cycle-overview__cycle-selector"
            [(ngModel)]="selectedCycle"
            [compareWith]="compareCycle"
            (selectionChange)="cycleChanged($event)"
          >
            <mat-option *ngFor="let cycle of cycles$ | async" [value]="cycle">
              <ng-container
                *ngIf="getFirstStartDate(cycle) as firstStartDate; else noFirstStartDate"
              >
                {{ cycle.cycleNumber }} ({{ firstStartDate | agrDate: 'dd-MM-yyyy' }})
              </ng-container>
              <ng-template #noFirstStartDate>
                {{ cycle.cycleNumber }}
              </ng-template>
            </mat-option>
          </mat-select>
        </div>
      </ng-container>

      <div class="mat-toolbar__right">
        <button
          mat-flat-button
          class="margin-right"
          (click)="deleteCycle()"
          *ngIf="selectedCycle"
          data-test="cycle-overview__delete-cycle"
        >
          <mat-icon>delete</mat-icon>{{ 'cycle.overview.delete-cycle' | translate }}
        </button>
        <button
          mat-flat-button
          (click)="editCycle()"
          *ngIf="selectedCycle"
          data-test="cycle-overview__edit-cycle"
        >
          <mat-icon>create</mat-icon>{{ 'cycle.overview.edit-cycle' | translate }}
        </button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="wrapper--spacing-vertical">
    <!-- NR OF ANIMALS PANEL -->
    <app-cycle-overview-panel
      *ngIf="selectedCycle"
      panelSubject="table-number-of-animals"
      [selectedCycle]="selectedCycle"
      [hasItems]="true"
      [showAddButton]="false"
      data-test="panel--number-of-animals"
    >
      <ng-container *ngIf="numberOfAnimalsRows; else noDataFound">
        <table class="table-m" data-test="table--number-of-animals">
          <thead>
            <tr>
              <th class="col-width-120">{{ 'cycle.overview.panel.barn' | translate }}</th>
              <th class="col-width-120">{{ 'cycle.overview.panel.section' | translate }}</th>
              <th class="col-width-120">{{ 'cycle.overview.panel.birthdate' | translate }}</th>
              <th class="col-width-120">{{ 'cycle.overview.panel.breed' | translate }}</th>
              <th class="col-width-60">{{ 'cycle.overview.panel.gender' | translate }}</th>
              <th class="col-width-120">{{ 'cycle.overview.panel.startdate' | translate }}</th>
              <th class="col-width-60 align-right">
                {{ 'cycle.overview.panel.amount' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of numberOfAnimalsRows">
              <td class="col-width-120">{{ row.barn }}</td>
              <td class="col-width-120">{{ row.section }}</td>
              <td class="col-width-120">{{ row.birthdate | agrDate: 'dd-MM-yyyy' }}</td>
              <td class="col-width-120">{{ row.breed }}</td>
              <td class="col-width-60">{{ row.gender | translate }}</td>
              <td class="col-width-120">{{ row.startdate | agrDate: 'dd-MM-yyyy' }}</td>
              <td class="col-width-60 align-right">{{ row.amount | number }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="align-right">
                <b>{{ 'cycle.overview.panel.total-amount' | translate }}:</b>
              </td>
              <td class="align-right">
                <b>{{ getTotalAmount() | number }}</b>
              </td>
            </tr>
          </tfoot>
        </table>
      </ng-container>
      <ng-template #noDataFound>
        <i>{{ 'cycle.overview.panel.no-data-found' | translate }}</i>
      </ng-template>
    </app-cycle-overview-panel>

    <!-- ORDER INFORMATION -->
    <app-cycle-overview-panel
      *ngIf="selectedCycle"
      panelSubject="order-information"
      [selectedCycle]="selectedCycle"
      [hasItems]="true"
      [showAddButton]="false"
      data-test="panel--order-information"
    >
      <ng-container *ngIf="orderInformationRows; else noDataFound">
        <table class="table-m" data-test="table--order-information">
          <thead>
            <tr>
              <th class="col-width-120">
                {{ 'cycle.overview.panel.section' | translate }}
              </th>
              <th class="col-width-120">
                {{ 'cycle.overview.panel.propagationcompany' | translate }}
              </th>
              <th class="col-width-120">{{ 'cycle.overview.panel.deliverydate' | translate }}</th>
              <th class="col-width-120">{{ 'cycle.overview.panel.breed' | translate }}</th>
              <th class="col-width-60">{{ 'cycle.overview.panel.gender' | translate }}</th>
              <th class="col-width-60 align-right">
                {{ 'cycle.overview.panel.numberordered' | translate }}
              </th>
              <th class="col-width-60 align-right">
                {{ 'cycle.overview.panel.numberavailable' | translate }}
              </th>
              <th class="col-width-60 align-right">
                {{ 'cycle.overview.panel.difference' | translate }}
              </th>
              <th class="col-width-60 align-right">
                {{ 'cycle.overview.panel.status' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of orderInformationRows">
              <td class="col-width-120">{{ row.sections.join(', ') }}</td>
              <td class="col-width-120">{{ row.propagationCompany }}</td>
              <td class="col-width-120">{{ row.deliverydate | agrDate: 'dd-MM-yyyy' }}</td>
              <td class="col-width-60">{{ row.breed }}</td>
              <td class="col-width-60">{{ row.gender | translate }}</td>
              <td class="col-width-60 align-right">{{ row.numberordered | number }}</td>
              <td class="col-width-60 align-right">{{ row.numberavailable | number }}</td>
              <td
                class="col-width-60 align-right"
                [ngClass]="
                  !row.isFulFilled
                    ? row.numberavailable - row.numberordered < 0
                      ? 'negative-difference'
                      : 'positive-difference'
                    : ''
                "
              >
                {{ row.numberavailable - row.numberordered | number }}
              </td>
              <td class="col-width-60 align-right">
                {{
                  'cycle.overview.panel.is-' + (row.isFulFilled ? 'fulfilled' : 'not-fulfilled')
                    | translate
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #noDataFound>
        <i>{{ 'cycle.overview.panel.no-data-found' | translate }}</i>
      </ng-template>
    </app-cycle-overview-panel>
  </div>
</agr-page-toolbar>
